import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { IconButton, Tooltip } from '@mui/material'
import { api } from '@/api/client'

/**
 * The two things anybody does with a document: print it, or keep the file.
 *
 * <p>Both, everywhere, and always this pair - a screen that offers one of them
 * on the invoice and the other on the receipt is a screen somebody learns twice.
 * Printing hands the document straight to the printer rather than saving a file
 * to open and print by hand, which is what the counter actually does with it.</p>
 *
 * <p>The office's own count of what left the building tells the two apart, so
 * "printed six times" and "downloaded six times" do not read as the same
 * thing.</p>
 */
export function DocumentActions({
  path,
  fileName,
  label,
  size = 'small',
  disabled,
}: {
  /** Where the PDF comes from. */
  path: string
  /** What the saved file is called, where the browser is not told. */
  fileName: string
  /** What the document is, for the tooltips: "invoice", "receipt". */
  label: string
  size?: 'small' | 'medium'
  disabled?: boolean
}) {
  return (
    <>
      <Tooltip title={`Print ${label}`}>
        <span>
          <IconButton size={size} disabled={disabled} onClick={() => void api.print(path)}>
            <LocalPrintshopIcon fontSize={size === 'small' ? 'small' : 'medium'} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={`Download ${label} as PDF`}>
        <span>
          <IconButton
            size={size}
            disabled={disabled}
            onClick={() => void api.download(path, undefined, fileName)}
          >
            <PictureAsPdfIcon fontSize={size === 'small' ? 'small' : 'medium'} />
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}
